module.exports = __webpack_public_path__ + "img/no-data.e01c5426.png";